import createDefaultTaskLine from './createDefaultTaskLine';
import initCells from '../../cells';

export default function (instance, task) {
  let row = createDefaultTaskLine(instance, task); // creates row div with class defined in templates.grid_row_class

  row = initCells(instance, row, task); // enriches row with cells

  return row;
}
